import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

export const TooltipArrow = styled.div`
  height: 1rem;
  position: absolute;
  width: 1rem;
  pointer-events: none;

  &::before {
    display: block;
    margin: auto;
    border-style: solid;
    width: 0;
    height: 0;
    content: '';
  }

  &::after {
    display: block;
    position: absolute;
    margin: auto;
    border-style: solid;
    width: 0;
    height: 0;
    content: '';
  }
`;

export const TooltipContainer = styled.div`
  background-color: var(--neutral-900);
  ${mixin.borderRadius()}
  border: 1px solid var(--neutral-900);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
  color: var(--neutral-10);
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  transition: opacity 0.3s;
  z-index: 99999999;
  ${({ width }) =>
    width &&
    css`
      max-width: ${width}px;
    `}
  ${(props) => {
    switch (props['data-popper-placement']) {
      case 'bottom':
        return css`
          ${TooltipArrow} {
            top: 0;
            left: 0;
            margin-top: -0.4rem;
          }

          ${TooltipArrow}::before {
            position: absolute;
            top: -1px;
            border-width: 0 0.5rem 0.4rem 0.5rem;
            border-color: transparent transparent var(--neutral-900) transparent;
          }

          ${TooltipArrow}::after {
            border-width: 0 0.5rem 0.4rem 0.5rem;
            border-color: transparent transparent var(--neutral-900) transparent;
          }
        `;
      case 'top':
        return css`
          ${TooltipArrow} {
            bottom: 0;
            left: 0;
            margin-bottom: -1rem;
          }

          ${TooltipArrow}::before {
            position: absolute;
            top: 1px;
            border-width: 0.4rem 0.5rem 0 0.5rem;
            border-color: var(--neutral-900) transparent transparent transparent;
          }

          ${TooltipArrow}::after {
            border-width: 0.4rem 0.5rem 0 0.5rem;
            border-color: var(--neutral-900) transparent transparent transparent;
          }
        `;
      case 'right':
        return css`
          ${TooltipArrow} {
            left: 0;
            margin-left: -0.7rem;
          }

          ${TooltipArrow}::before {
            border-width: 0.5rem 0.4rem 0.5rem 0;
            border-color: transparent var(--neutral-900) transparent transparent;
          }

          ${TooltipArrow}::after {
            top: 0;
            left: 6px;
            border-width: 0.5rem 0.4rem 0.5rem 0;
            border-color: transparent var(--neutral-900) transparent transparent;
          }
        `;
      case 'left':
        return css`
          ${TooltipArrow} {
            right: 0;
            margin-right: -0.7rem;
          }

          ${TooltipArrow}::before {
            border-width: 0.5rem 0 0.5rem 0.4em;
            border-color: transparent transparent transparent var(--neutral-900);
          }

          ${TooltipArrow}::after {
            top: 0;
            left: 3px;
            border-width: 0.5rem 0 0.5rem 0.4em;
            border-color: transparent transparent transparent var(--neutral-900);
          }
        `;
      default:
        return null;
    }
  }}
`;
